module.exports = __webpack_public_path__ + "static/img/advertise-laptop-image.5e448cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertise-laptop-image.png
// module id = 8wgR
// module chunks = 1